import React from 'react'
import './style2.css'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import rotas from '../../services/rotas'
import { useKeycloak } from '@react-keycloak/web'
const ForbidenPage = () => {
  const { keycloak } = useKeycloak()
  const navigate = useNavigate()
  return (
    <div
      style={{
        position: 'absolute',
        top: '0',
        left: '0',
        overflow: 'hidden',
        width: '100vw',
        height: '100vh',
        zIndex: '2000',
        background: 'white'
      }}
    >
      <div className="error-wrapper" id="error-wrapper">
        <div id="error-page">
          <div id="error-inner">
            <h3>Erro!</h3>
            <div className="box-404">
              <div>403</div>
            </div>
            <h2>Acesso não autorizado</h2>
          </div>

          <Button
            onClick={() => {
              keycloak.logout()
              navigate(rotas.home)
            }}
            variant="contained"
            color="error"
          >
            Voltar para o Login
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ForbidenPage
